import React from 'react';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import Steps from '../components/SoftwareServices/HowWeDo/Steps';
import PartialsQuestion from '../components/Partials/PartialsQuestion';
import About from '../components/SoftwareServices/HowWeDo/About';
import Details from '../components/SoftwareServices/HowWeDo/Details';

const HowWeDo = () => {
  return (
    <Layout
      title="How we work on software | Ulam Labs"
      description="Our software development process help us to provide time-to-market solutions faster. Work with agile developers on your project."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">How we work</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="how-we-do text-format">
        <About />
        <Details />
        <Steps />
      </div>
      <PartialsQuestion />
    </Layout>
  );
};

export default HowWeDo;
